import React from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";
import { Error } from "../_common/Error";
import { FullPageSpinner } from "../_common/Spinner";

function VendorDatatable({
  vendors,
  isLoading,
  error,
  setOpensidePanel,
  setVendorDetails,
  confirmDelete,
}) {
  const columns = [
    {
      Header: "Vendor Name",
      accessor: "name",
      sortType: "basic",
    },
    {
      Header: "Email Address",
      accessor: "email",
      sortType: "basic",
    },
    {
      Header: "Street",
      accessor: "streetAddress",
      sortType: "basic",
    },
    {
      Header: "City",
      accessor: "city",
      sortType: "basic",
    },
    {
      Header: "State",
      accessor: "state",
      sortType: "basic",
    },
    {
      Header: "Zipcode",
      accessor: "zipcode",
      sortType: "basic",
    },
    {
      Header: "Phone #",
      accessor: "phone",
      sortType: "basic",
    },
    {
      Header: "Extension",
      accessor: "phoneExt",
      sortType: "basic",
    },
    {
      Header: "Fax #",
      accessor: "fax",
      sortType: "basic",
    },
    {
      Header: "Action",
      accessor: "id",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div>
          <a
            className="edit"
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              setOpensidePanel(true);
              setVendorDetails(row.original);
            }}
            style={{
              marginRight: "8px",
              color: "#1bbc9b",
            }}
          >
            <i className="fa fa-pencil"></i>
          </a>
          <a
            className="delete"
            href="#!"
            onClick={(e) => {
              e.preventDefault();
              confirmDelete(row.original);
            }}
            style={{ color: "#e7505a" }}
          >
            <i className="fa fa-trash-o"></i>
          </a>
        </div>
      ),
      editRow({ id }) {
        console.log(id);
        return false;
      },
    },
  ];

  if (isLoading) {
    return <FullPageSpinner />;
  }

  if (error) {
    return <Error message={error} />;
  }

  const hasVendors = vendors && vendors.length;
  if (!hasVendors) {
    return (
      <div>
        <h6 style={{ textAlign: "center", fontWeight: "bold" }}>
          All your Vendors will show here. Use the 'Add New +' button to add an
          Vendor.
        </h6>
      </div>
    );
  }

  return <VendorTable vendorsData={vendors} columns={columns} />;
}

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <span>
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        type="search"
        className="form-control input-sm input-small input-inline"
      />
    </span>
  );
}

function VendorTable({ vendorsData, columns, updateMyData }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = React.useMemo(() => vendorsData, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      updateMyData,
      initialState: {
        sortBy: [
          {
            id: "name",
            desc: false,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy
  );

  return (
    <div className="dataTables_wrapper no-footer">
      <div className="dataTables_filter">
        <label>
          Search:
          {
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          }
        </label>
      </div>
      <table
        id="Vendor-Data-Table"
        className="table table-striped table-hover table-bordered dataTable no-footer"
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  className={
                    !column.disableSortBy
                      ? column.isSorted
                        ? column.isSortedDesc
                          ? "sorting_desc"
                          : " sorting_asc"
                        : "sorting"
                      : ""
                  }
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export { VendorDatatable };
